export const impossibleCancelReasons = {
  IN_LOGISTIC_PROCESS: 'IN_LOGISTIC_PROCESS',
  COLLECT_DATE_PASSED: 'COLLECT_DATE_PASSED',
  ACTIVITY_IN_LESS_THAN_24H: 'ACTIVITY_IN_LESS_THAN_24H',
  MAX_DELAY_PASSED: 'MAX_DELAY_PASSED'
}